import type { FC } from 'react';
import clsx from 'clsx';
import type { LinksFunction } from '@remix-run/node';

import type { SharedAnnouncementBarProps } from './shared-announcement-bar.types';
import styles from './shared-announcement-bar.css?url';

export const links: LinksFunction = () => [{ rel: 'stylesheet', href: styles }];

const DEFAULT_ANNOUNCEMENT_TEXT = (
  <>100% Free&nbsp;&nbsp;•&nbsp;&nbsp;No account required</>
);

export const SharedAnnouncementBar: FC<SharedAnnouncementBarProps> = ({
  className = '',
  children = DEFAULT_ANNOUNCEMENT_TEXT,
  variant = 'gradient',
}) => {
  const classes = clsx(
    'shared-announcement-bar',
    {
      'shared-announcement-bar--light-blue': variant === 'light-blue',
    },
    className,
  );

  return <div className={classes}>{children}</div>;
};
